import base from './base2.repository';
export default {
    requestAssistance: (userId) => base.post('vigilance/request-assistance', {userId}),
}



// WEBPACK FOOTER //
// ./src/repositories/services.repository.js